import { render, staticRenderFns } from "./ActionsList.vue?vue&type=template&id=35214784&scoped=true"
import script from "./ActionsList.vue?vue&type=script&lang=js"
export * from "./ActionsList.vue?vue&type=script&lang=js"
import style0 from "./ActionsList.vue?vue&type=style&index=0&id=35214784&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "35214784",
  null
  
)

export default component.exports